import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DynamicLoadProgress from './components/common/DynamicLoadProgress';
import styled from 'styled-components';
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import Routes from './Routes';
import LeftSidebar from './components/navigation/LeftSidebar';
import AppBar from './components/header/AppBar';
import { Images, Metrics } from './themes';
import WebSocket from './services/WebSocket';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: url(${Images.backgroundDimmed});
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-width: ${Metrics.minWidth}px;
`;

const App = () => {
  useEffect(() => console.log(`Version ${process.env.REACT_APP_VERSION}`), []);
  const authed = useSelector((state) => state.auth.isAuthenticated);
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <React.Suspense fallback={<DynamicLoadProgress />}>
      <div className="App">
        <Wrapper className="AppWrapper">
          <CssBaseline />
          {authed && (
            <>
              <AppBar handleDrawerToggle={handleDrawerToggle} />
              <LeftSidebar handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} />
              <WebSocket />
            </>
          )}
          <Routes authed={authed} />
        </Wrapper>
      </div>
    </React.Suspense>
  );
};

export default App;
